module.exports = __webpack_public_path__ + "static/changing-the-face-of-science-cta-banner-1920x515-11e0dcde3b915ec121a8ffec5d5a2a4f.jpg";